<template>
  <div v-loading="loading" class="work-list-page">
    <el-form ref="form" :model="queryParams" label-width="50px" style="display: flex;margin-top: 20px;justify-content: space-between;">
      <el-form-item label="编号" prop="id">
        <el-input v-model="queryParams.id"></el-input>
      </el-form-item>
      <div style="display: flex;">
        <el-button type="primary" style="height: 40px; margin-left: 20px;" @click="initData">查询</el-button>
        <el-button type="primary" style="height: 40px; margin-left: 20px;" @click="reset">重置</el-button>
      </div>

    </el-form>
    <el-table :data="dataList" style="width: 100%" default-expand-all height="600">
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="p20" v-cloak>
            <el-table :data="props.row.tableData" style="width: 100%">
              <el-table-column :label="item.required ? `*${item.labelName}` : item.labelName" align="center" v-for="item in props.row.tableTitleList"
                :prop="item.labelField" :key="item.labelField" v-show="item.show">
                <template slot="header">
                  <span v-if="item.required"><span style="color: red;">* </span>{{item.labelName}}</span>
                  <span v-else >{{item.labelName}}</span>
                </template>
                <template slot-scope="scope">
                  <div v-if="item.fieldType == 'upload'">
                    <p style="color: green; cursor: pointer;" v-if="scope.row[item.labelField]" @click="showPdf(scope.row[item.labelField].url)">{{ scope.row[item.labelField].name }} </p>
                    <p v-else style="color: red;">未上传</p>
                  </div>
                  <p v-else>{{ scope.row[item.labelField] }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="编号" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="赛区" align="center">
        <template slot-scope="scope">
          {{ scope.row.data.division }}
        </template>
      </el-table-column>
      <el-table-column label="团队名称" align="center">
        <template slot-scope="scope">
          {{ scope.row.data.teaName }}
        </template>
      </el-table-column>
      <el-table-column label="团队联系人" align="center">
        <template slot-scope="scope">
          {{ scope.row.data.teamContact }}
        </template>
      </el-table-column>
      <el-table-column label="团队电话" align="center">
        <template slot-scope="scope">
          {{ scope.row.data.teamPhone }}
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 20px;">
      <el-pagination @current-change="handleCurrentChange" :page-size="queryParams.pageSize" layout="prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getParticipantData } from '@/api/info/index'
import { listData } from '@/api/work/workdata'
import { listWorksCategoryConf } from '@/api/work/worksCategoryConf'
import { listWorkfield } from '@/api/work/workfield'
import {listStorage} from '@/api/system/objectStorage'

export default {
  props: {

  },
  data () {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        show: true,
        siteId: this.siteId,
        createBy: this.$store.state.user.userId
      },
      dataList: [],
      total: 0,
      loading: true,
      workTypeList: []
    }
  },
  components: {

  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.initData()
    this.getWorkType()
  },
  watch: {

  },
  methods: {
    async initData () {
      this.loading = true
      await getParticipantData(this.baseURL, this.queryParams).then(async (response) => {
        let list = []
        response.rows.forEach((item) => {
          let obj = {}
          obj = item
          obj.data = JSON.parse(item.data)
          list.push(obj)
        })
        this.total = response.total
        for (let i = 0; i < list.length; i++) {
          await listData(this.siteURL, {
            siteId: this.siteId,
            userId: list[i].userId,
            status: 1
          }).then(res => {
            list[i].workList = []
            list[i].tableData = []
            res.rows.forEach(row => {
              list[i].workList.push(row.workDynamicData)
            })
            list[i].workList.forEach(async item => {
              item.data = JSON.parse(item.data)
              await listWorkfield(this.siteURL, {
                siteId: this.siteId,
                formType: item.categoryId
              }).then(async res2 => {
                let obj = {}
                list[i].tableTitleList = res2.rows
                await res2.rows.forEach(row => {
                  if (item.data[row.labelField] && row.fieldType == 'upload') {
                    listStorage(this.systemURL, {
                      remark: item.data[row.labelField]
                    }).then(res3 => {
                      obj[row.labelField] = {
                        name: res3.rows[0].fileName,
                        url: res3.rows[0].path
                      }
                    })
                  } else {
                    obj[row.labelField] = item.data[row.labelField]
                  }
                })
                this.$set(list[i], 'tableData', [obj])
              })
            })
          })
        }
        setTimeout(() => {
          this.dataList = JSON.parse(JSON.stringify(list))
          this.$forceUpdate()
          this.loading = false
        }, 1000)
      })
    },
    getWorkType () {
      listWorksCategoryConf(this.baseURL, {
        siteId: this.siteId
      }).then(async res => {
        this.workTypeList = res.rows
      })
    },
    getTypeName (id) {
      let type = this.workTypeList.filter((type) => {
        return type.id == id
      })
      return type[0].name
    },
    handleCurrentChange (val) {
      this.queryParams.pageNum = val
      this.initData()
    },
    reset () {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        show: true,
        siteId: this.siteId,
        createBy: this.$store.state.user.userId
      }
      this.initData()
    },
    getFileInfo (remark) {
      listStorage(this.systemURL, {
        remark
      }).then(res => {
        return {
          name: res.rows[0].fileName,
          url: res.rows[0].path
        }
      })
    },
    showPdf (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped lang='scss'>
.work-list-page {
  padding: 20px;
}

.p20 {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/WorkListPage.vue